import { AbstractControl, ValidatorFn } from "@angular/forms";


export function patternIfFilledValidator(pattern: RegExp): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) {
      return null;
    }
    return pattern.test(control.value) ? null : { pattern: { value: control.value } };
  };
}